// Looking at your Navbar.jsx file, update the isAuthenticated section:

import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar({ isAuthenticated, user, onLogout }) {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/images/logo.svg" alt="MyJava Company Logo" className="navbar-logo-image" />
        </Link>
        
        <div className="navbar-menu">
          {isAuthenticated ? (
            <>
              <span className="welcome-text">
                Welcome, {user.name}
              </span>
              
              {/* Add Settings link here */}
              <Link to="/settings" 
                className="icon-link settings-link" 
                title="User Settings">
                👤
              </Link>
              
              {user.role === 'admin' && (
                <a href="/admin" 
                  className="admin-gear-link" 
                  title="Admin Settings"
                  target="_blank"
                  rel="noopener noreferrer">
                  ⚙️
                </a>
              )}
              <button onClick={onLogout} className="logout-button">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link">
                Login
              </Link>
              <Link to="/register" className="nav-link register-link">
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;